module.exports = __webpack_public_path__ + "static/media/adminBurger.5f1b3fab.svg";